<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="orgrelpointinfo" :rules="rules" ref="orgpointrelrule" label-width="120px" class="">
			<el-row>
				<el-col :span="16">
					<el-form-item label="计算点位" prop="cid" >
						<el-select style="width: 100%;" filterable clearable   :disabled="!editok" v-model="orgrelpointinfo.cid"
							placeholder="请选择计算点位" @change="pointChange">
							<el-option v-for="item in calcpointlist" :key="item.id" :label="item.objectid +' | '+ item.propertyid +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="是否默认显示" prop="defaultshow" >
						<el-select style="width: 100%;" :disabled="!editok" v-model="orgrelpointinfo.defaultshow" placeholder="请选择是否默认显示">
							<el-option v-for="item in statelist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row >
				<el-col :span="12">
					<el-form-item label="是否首页显示" prop="homepageshow" >
						<el-select style="width: 100%;" :disabled="!editok" v-model="orgrelpointinfo.homepageshow" placeholder="请选择是否首页显示">
							<el-option v-for="item in statelist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="排序" prop="idx">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="orgrelpointinfo.idx" :precision="2" :min="0" :max="999" label="排序"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="图标" prop="iconurl">
						<el-input clearable :disabled="!editok" v-model="orgrelpointinfo.iconurl" ></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveOrgPointRel">保存</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { addOrgCalcRel, editOrgCalcRel, queryCalcPointsByPage } from '/static/apiUrl.js'
	export default {
		name : 'AddOrgPoint',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				orgrelpointinfo : {
					id: "",
					objectid: "",
					orgid : '',
					caclid: "",
					cid : '',
					idx: 1,
					defaultshow : '',
					homepageshow : '',
					iconurl : '',
					orgname : '',
				},
				statelist : [
					{
						code : 'Y',
						name : '显示'
					},
					{
						code : 'N',
						name : '不显示'
					}
				],
				rules:{
					defaultshow: [
						{ required: true, message: '请选择是否默认显示', trigger: 'blur' }
					],
					homepageshow: [
						{ required: true, message: '请选择是否首页显示', trigger: 'blur' }
					],
				},
				calcpointlist : [],
				
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			selectedorgpoint: {
				type: Object,
				required: false
			},
			add : {
				type : Boolean,
				required : false,
				default : false,
			},
			selectedorg: {
				type: Object,
				required: true
			},
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			selectedorg : {
				immediate: true,
				handler(newVal) {
					this.orgrelpointinfo.orgid = newVal.id
					this.orgrelpointinfo.orgname = newVal.name
					this.initData()
				}
			},
			selectedorgpoint: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.orgrelpointinfo.id = newVal.id
						this.orgrelpointinfo.objectid = newVal.objectid
						this.orgrelpointinfo.cid = newVal.cid
						this.orgrelpointinfo.caclid = newVal.caclid
						this.orgrelpointinfo.idx = newVal.idx
						this.orgrelpointinfo.defaultshow = newVal.defaultshow
						this.orgrelpointinfo.homepageshow = newVal.homepageshow
						this.orgrelpointinfo.iconurl = newVal.iconurl
					}else{
						this.orgrelpointinfo.id = ''
						this.orgrelpointinfo.objectid = ''
						//this.orgrelpointinfo.orgid = ''
						this.orgrelpointinfo.cid = ''
						this.orgrelpointinfo.caclid = ''
						this.orgrelpointinfo.idx = 1
						this.orgrelpointinfo.defaultshow = ''
						this.orgrelpointinfo.homepageshow = ''
						this.orgrelpointinfo.iconurl = ""
					}
				}
			},
		},
		methods: {
			initData(){
				this.calcpointlist = []
				queryCalcPointsByPage({
					pagenum : 1,
					pagesize : 1000
				}).then(res => {
					if(0 == res.code){
						this.calcpointlist = res.datas.data
					}
				})
			},
			pointChange(val){
				//console.log(val)
				this.calcpointlist.forEach((item) => {
					if(item.id == val){
						this.orgrelpointinfo.objectid = item.objectid
						this.orgrelpointinfo.caclid = item.propertyid
					}
				})
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRelRefrash",false,false)
				}
			},
			saveOrgPointRel(){
				this.$refs["orgpointrelrule"].validate((valid) => {
					if (valid) {
						if(this.orgrelpointinfo.objectid == '' || this.orgrelpointinfo.orgid == '' || this.orgrelpointinfo.caclid == ''){
							this.$message({
								showClose: true,
								message: "请完善数据",
								type: 'warning'
							});
							return;
						}
						if(this.orgrelpointinfo.id != null && this.orgrelpointinfo.id != ''){  //编辑
							editOrgCalcRel(this.orgrelpointinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "更新成功",
										type: 'success'
									});
									this.$emit("needRelRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}else{ //新增
							addOrgCalcRel(this.orgrelpointinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "添加成功",
										type: 'success'
									});
									this.$emit("needRelRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>